import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { getOrderPath } from '../../../../../../../../../../features/order/order-routing';
import { AccountBreadcrumb } from '../../../../../../../../../../features/registration/account/account-breadcrumb';

export const Route = createFileRoute('/_app/_clearing-core/registration/account/$accountId/_account/_detail/order/equity/_equity')({
  preload: false,
  loader: ({ params }) =>
    ({
      breadcrumb: buildBreadcrumb({
        id: `account-${params.accountId}-order-list`,
        label: <AccountBreadcrumb accountId={params.accountId} displayIdOnly />,
        to: getOrderPath({ kind: 'list', keys: { accountId: params.accountId } }),
      }),
    }) satisfies AggregateBreadcrumb,
});
